import axios from 'axios';

const API_AUTH_TOKEN =
	'Basic MnZGa1ZnbkJ1ZEtXWm9yWGJzaTlWTkZpeWZuMXNuQWhfUFlzRzI3MEZFNTNmMlJtM3B2VFdyUl9XYmFaZnJma1FoWWRRQVlCdWY0TmZvYVVta0FCYUpGV1FTYmE3b3dFV1Zud2M0MkN6X2RjenNiY0prcTc3ZDZIRVFIT0VWdVI6';

const axiosInstance = axios.create({
	headers: {
		'X-Requested-With': 'XMLHttpRequest'
	}
});

axiosInstance.interceptors.request.use(
	(config) => {
		config.headers['Authorization'] = API_AUTH_TOKEN;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

const source = axios.CancelToken.source();
const cancelToken = source.token;

export { axiosInstance as axios, cancelToken, source, API_AUTH_TOKEN };
